import React from "react";
import { useState, useEffect } from "react";
import { GET_OTHER_EXPENSE_BY_ID } from "./QueryOperation";
import { useApolloClient } from "@apollo/client";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import LoopIcon from '@mui/icons-material/Loop';
import { useSettings } from "hooks/useSettings";
import { ChangeFormatDb } from "utils/DateFormatting";
import { DateFormatting } from "utils/DateFormatting";
const ViewOther = ({ id, onClose }) => {
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [other, setother] = useState({});
  const { currency, dateFormat } = useSettings();
  useEffect(() => {
    const getOtherById = async () => {
      try {
        const { data } = await client.query({
          query: GET_OTHER_EXPENSE_BY_ID,
          variables: {
            getOtherByIdId: id,
          },
        });
        console.log(data.getOtherById);
        setother(data.getOtherById);
        setvisibility(true);
      } catch (error) {
        console.log(error.message);
      }
    };
    getOtherById();
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">ACTIVO</label>
            <TextField disabled value={other?.active?.description} />
          </Box>

          <Box sx={style}>
            <label for="my-input">TIPO</label>
            <TextField disabled value={other?.type?.description} />
          </Box>
          <Box sx={style}>
            <label for="my-input">NOMBRE</label>
            <TextField disabled value={other?.name} />
          </Box>
          <Box sx={style}>
            <label for="my-input">REFERENCIA</label>
            <TextField disabled value={other?.reference} />
          </Box>
          <Box sx={style}>
            <label for="my-input">FECHA</label>
            <TextField
              disabled
              value={DateFormatting(other?.date,dateFormat)}
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">TIEMPO</label>
            <TextField
              disabled
              value={other?.time}
            />
          </Box>
        </Box>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(3, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">CANTIDAD</label>
            <TextField disabled value={other?.amount} />
          </Box>
          <Box sx={style}>
            <label for="my-input">COSTO</label>
            <TextField disabled value={currency+" " + other?.cost} />
          </Box>
          <Box sx={style}>
            <label for="my-input">TOTAL</label>
            <TextField disabled value={currency+" " + other?.total} />
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={onClose}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default ViewOther;
